import styles from './CircledChevronUp.module.scss';
import classNames from 'classnames/bind';

let cx = classNames.bind(styles);

export function CircledChevronUp({ className }) {
	const classNameArray = className?.split(' ') || [];
	return (
		<svg width="100%" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg" className={cx(['circled-chevron-up-icon', ...classNameArray])} aria-hidden="true">
			<path d="M12.5 25.803a12.5 12.5 0 1 1 12.5-12.5 12.513 12.513 0 0 1-12.5 12.5Zm0-23.077a10.577 10.577 0 1 0 10.577 10.577A10.589 10.589 0 0 0 12.5 2.726Zm5.488 13.18a.962.962 0 0 0 0-1.36L13.18 9.738a.962.962 0 0 0-1.36 0l-4.808 4.808a.962.962 0 1 0 1.36 1.36l4.128-4.128 4.127 4.129a.962.962 0 0 0 1.361 0Z" fill="#000" />
		</svg>
	);
}
